import * as React from "react"
import {Box} from "@mui/material";

import RawMatcherTargetProduct from "./Product";
import RawMatcherTargetActions from "./Actions";


export default function RawMatcherTarget({ targetIndex, data, handleChangeIndex, isLoadingMapping}) {
    return <Box sx={{
        width: 1,
        height: 1,
        backgroundColor: 'background.neutral',
        borderRadius: 1,
        py: 5,
        px: 6.5,
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        justifyContent: 'flex-start'
    }}>
        <RawMatcherTargetActions
            targetIndex={targetIndex}
            handleChangeIndex={handleChangeIndex}
			isLoadingMapping={isLoadingMapping}
        />

        <RawMatcherTargetProduct data={data} />
    </Box>
}